var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"background"},[_c('NavBar'),_c('Header'),_c('Inscricoes'),_c('Cronometro'),_c('SobreEvento'),_c('Programacao'),_c('InscricaoGarante'),_c('PerguntasFrequentes'),_c('Patrocinadores'),_c('CodigoConduta'),_c('Local'),_c('FooterEvento')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }